import { Search, Heart, MessageCircle, PartyPopper } from 'lucide-react';

const steps = [
  {
    icon: Search,
    title: 'Explora',
    description: 'Navega por categorías y descubre proveedores cerca de ti con reseñas verificadas.',
  },
  {
    icon: Heart,
    title: 'Guarda tus favoritos',
    description: 'Crea tu lista de deseos y compara opciones tranquilamente.',
  },
  {
    icon: MessageCircle,
    title: 'Contacta directamente',
    description: 'Habla con los proveedores sin intermediarios y negocia tus condiciones.',
  },
  {
    icon: PartyPopper,
    title: '¡Celebra!',
    description: 'Disfruta de tu boda perfecta con los mejores profesionales.',
  },
];

const HowItWorks = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-primary font-medium mb-2 block">Fácil y sin complicaciones</span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold text-foreground mb-4">
            ¿Cómo funciona?
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Planifica tu boda de forma sencilla, sin necesidad de wedding planner.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative text-center group">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-primary/30 to-primary/10" />
              )}
              
              <div className="relative z-10 inline-flex items-center justify-center w-24 h-24 rounded-full bg-card border-2 border-primary/20 mb-6 group-hover:border-primary group-hover:shadow-card transition-all duration-300">
                <step.icon className="w-10 h-10 text-primary" />
                <span className="absolute -top-2 -right-2 w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center font-bold text-sm">
                  {index + 1}
                </span>
              </div>
              
              <h3 className="font-serif text-xl font-semibold text-foreground mb-3">
                {step.title}
              </h3>
              <p className="text-muted-foreground text-sm">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
